import { render, staticRenderFns } from "./Billing_Dash.vue?vue&type=template&id=f51ce918&"
import script from "./Billing_Dash.vue?vue&type=script&lang=js&"
export * from "./Billing_Dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports